import React from "react";
import StudentPageContainer from "@/components/layouts/StudentPageContainer";

const ExamNoActiveSession: React.FC = () => {
  return (
    <StudentPageContainer>
      <div className="h-screen flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-xl font-bold mb-2">No Active Section</h2>
          <p className="text-gray-600">
            There is no active section for this exam.
          </p>
        </div>
      </div>
    </StudentPageContainer>
  );
};

export default ExamNoActiveSession;
